import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as messageHelper from "../helpers/messageHelper";
import * as handlers from "../constants/handlers";

export const addUser = (username, password, barcode, autoLogin) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_USER,
        params: {
            username: username,
            password: password,
            barcode: barcode,
            autoLogin: autoLogin
        }
    },
    method: handlers.ADD_USER,
    tabId: 0
});

export const editUser = (id, password, barcode, autoLogin) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_UPDATE_USER,
        params: {
            userId: id,
            password: password,
            barcode: barcode,
            autoLogin: autoLogin
        }
    },
    method: handlers.UPDATE_USER,
    tabId: 0
});

export const editUserWithoutPassword = (id, barcode, autoLogin) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_UPDATE_USER,
        params: {
            userId: id,
            barcode: barcode,
            autoLogin: autoLogin
        }
    },
    method: handlers.UPDATE_USER,
    tabId: 0
});

export const editPassword = (oldPassword, newPassword) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_CHANGE_USER_PASSWORD,
        params: {
            oldPassword: oldPassword,
            newPassword: newPassword
        }
    },
    method: handlers.CHANGE_USER_PASSWORD,
    tabId: 0
});
export const passwordIsNotUniqueMessage = () => messageHelper.getErrorMessageAction("flashMessage.passwordIsNotUnique");

export const deleteUser = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_DELETE_USER,
        params: {
            userId: id
        }
    },
    method: handlers.DELETE_USER,
    tabId: 0
});

export const restoreUser = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_DELETE_USER,
        params: {
            userId: id,
            deleted: false
        }
    },
    method: handlers.RESTORE_USER,
    tabId: 0
});

export const getSelectedUserGroups = (id, isLocal) => ({
    type: actionTypes.LOAD_SELECTED_USER_GROUP_LIST,
    payload: {
        userId: id,
        isLocal: isLocal
    }
});

export const addUserIntoGroup = (userId, groupId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_USER_INTO_GROUP,
        params: {
            userId: userId,
            userGroupId: groupId
        }
    },
    method: handlers.ADD_USER_INTO_GROUP,
    tabId: 0
});

export const removeUserFromGroup = (userId, groupId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_REMOVE_USER_FROM_GROUP,
        params: {
            userId: userId,
            userGroupId: groupId
        }
    },
    method: handlers.REMOVE_USER_FROM_GROUP,
    tabId: 0
});

export const removeUserFromAllGroups = (userId) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_REMOVE_USER_FROM_ALL_GROUPS,
        params: {
            userId: userId
        }
    },
    method: handlers.REMOVE_USER_FROM_ALL_GROUPS,
    tabId: 0
});

export const getAllUsers = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_USERS,
        params: {
            activeOnly: false
        }
    },
    method: handlers.GET_ALL_USERS,
    tabId: 0
});

export const getAllUserGroups = () => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_GET_ALL_USER_GROUPS
    },
    method: handlers.GET_ALL_USER_GROUPS,
    tabId: 0
});
